const WrongGeometryFallback = () => (
  <div className="w-[340px] h-[340px] bg-color4 flex items-center justify-center">
    <p className="text-color2">Není možné načíst geometrii objektu</p>
  </div>
);

export default WrongGeometryFallback;
